import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_LIVE_BENEFIT_GROUP, GET_LIVE_BENEFIT_GROUP_SUCCESS, GET_LIVE_BENEFIT_GROUP_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getLiveBenefitGroup({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/benefit-type/airport-transfer/configuration/fetch-live-benefit-groups`,
      method: 'GET',
      params: payload?.urlParams,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_LIVE_BENEFIT_GROUP_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_LIVE_BENEFIT_GROUP_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_LIVE_BENEFIT_GROUP_ERROR, payload: error });
  }
}

export function* watchgetLiveBenefitGroup() {
  yield takeEvery(GET_LIVE_BENEFIT_GROUP, getLiveBenefitGroup);
}

function* getLiveBenefitGroupSaga() {
  yield all([fork(watchgetLiveBenefitGroup)]);
}

export default getLiveBenefitGroupSaga;
